import moment from 'moment';

import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';
import { ISchedulesRepository } from 'shared/domain/repositories';
import { Schedule, IVectisSchedule } from 'shared/infra/adapters';

export default class VectisSchedulesRepository implements ISchedulesRepository {
  constructor(private httpProvider: IHTTPProvider) {}

  public create: ISchedulesRepository['create'] = async ({
    unitId,
    areaIds,
    customer,
    schedule,
  }) => {
    return this.httpProvider.put('agendas/agendamento', {
      dataHoraInicio: `${moment(schedule.date).format('DD/MM/YYYY')} ${
        schedule.time
      }`,
      origem: 'SITE',
      idUnidade: unitId,
      itensContrato: areaIds.map(id => ({ id })),
      cpf: customer.document,
      email: customer.email,
      intervaloDuracao: schedule.duration,
      agendaAvaliacao: false,
    });
  };

  public findAll: ISchedulesRepository['findAll'] = async params => {
    if (params.filter === 'PAST') {
      return this.getSchedules(params);
    }

    return this.getFutureSchedules(params);
  };

  public deleteOne: ISchedulesRepository['deleteOne'] = async ({
    scheduleId,
    reason,
  }) => {
    return this.httpProvider.post(`agendas/${scheduleId}/cancelamento`, {
      motivo: reason,
      origem: 'SITE',
    });
  };

  public update: ISchedulesRepository['update'] = async ({
    unitId,
    schedule,
  }) => {
    return this.httpProvider.put(`agendas/${schedule.id}/reagendamento`, {
      dataHoraInicio: `${moment(schedule.date).format('DD/MM/YYYY')} ${
        schedule.time
      }`,
      origem: 'SITE',
      idUnidade: unitId,
    });
  };

  public checkEligibility: ISchedulesRepository['checkEligibility'] = async ({
    scheduleId,
  }) => {
    const { elegivel, mensagem } = await this.httpProvider.get<{
      elegivel: boolean;
      mensagem: string;
    }>(`agendas/${scheduleId}/reagendamento/elegibilidade`, {
      // Elegibilidade muda a qualquer momento (pendência financeira) - nunca pode vir de cache
      // (browser ou CDN intermediário), mesmo com Cache-Control: no-store do backend.
      params: { _t: Date.now() },
      headers: { 'Cache-Control': 'no-cache' },
    });

    return { eligible: elegivel, reason: mensagem };
  };

  private getSchedules: ISchedulesRepository['findAll'] = async ({
    customerId,
    page,
    size,
  }) => {
    const { totalPages, data } = await this.httpProvider.get<{
      totalPages: number;
      data: IVectisSchedule[];
    }>(`/area-cliente/agendamentos/historico/${customerId}`, {
      params: { page, size },
    });

    return {
      totalPages,
      schedules: data.map(schedule => new Schedule(schedule)),
    };
  };

  private getFutureSchedules: ISchedulesRepository['findAll'] = async ({
    customerId,
  }) => {
    const schedules = await this.httpProvider.get<IVectisSchedule[]>(
      `/area-cliente/agendamentos/futuros/${customerId}`,
    );

    return {
      totalPages: 1,
      schedules: schedules.map(schedule => new Schedule(schedule)),
    };
  };
}
